import {createAction} from '@reduxjs/toolkit'
import {UpdateSiteSettingsResponse} from '@wix/ambassador-wix-events-web/types'
import {createAsyncAction} from '../../components/details-page/Widget/services/redux-toolkit'
import {GetCommonState, SiteSettingsSettings} from '../types/state'
import {callAPI, createActions} from './data-action-helper'

export const setSiteSettings = createAction<SiteSettingsSettings>('SET_SITE_SETTINGS')

export const GET_SITE_SETTINGS_OLD = createActions('GET_SITE_SETTINGS_OLD')
export const UPDATE_SITE_SETTINGS_OLD = createActions('UPDATE_SITE_SETTINGS_OLD')

export const getSiteSettingsOld = () => (dispatch: Function) => dispatch(callAPI(GET_SITE_SETTINGS_OLD))

export const getSiteSettings = createAsyncAction<any>('GET_SITE_SETTINGS', async (_, {extra: {serverApi}}) =>
  serverApi.getSiteSettings(),
)

export const updateSiteSettingsOld =
  (payload: Partial<SiteSettingsSettings>) => (dispatch: Function, getState: GetCommonState) => {
    const settings = {...getState().siteSettings.settings, ...payload}

    return dispatch(callAPI(UPDATE_SITE_SETTINGS_OLD, settings))
  }

export const updateSiteSettings = createAsyncAction<UpdateSiteSettingsResponse, Partial<SiteSettingsSettings>>(
  'UPDATE_SITE_SETTINGS',
  async (payload, {getState, extra: {serverApi}}) => {
    const settings = {...getState().siteSettings.settings, ...payload}

    return serverApi.updateSiteSettings(settings)
  },
)
